import { DataGridCellParams } from "@components/common/data-grid/adm-data-grid-types";
import { AdmCompany } from "@custom-types/base-types";

/** The column definition for the search workspaces table with the field property typed */
export type SearchWorkspacesTableGridColDef = DataGridCellParams<
  AdmCompany,
  SearchWorkspacesTableColumnField
>;

/** The column fields that can be used in the search workspaces table */
export type SearchWorkspacesTableColumnField =
  "name" | "projects" | "members" | "createdAt" | "options";

/** The labels for the columns in the search workspaces table */
export const SEARCH_WORKSPACES_TABLE_COLUMN_LABELS: Record<
  SearchWorkspacesTableColumnField,
  string
> = {
  name: "Name",
  projects: "Number of Projects",
  members: "Number of Members",
  createdAt: "Created At",
  options: "",
};
